
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trips",
      function () {
        return require("private-next-pages/trips/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trips"])
      });
    }
  